export default "__VITE_ASSET__4fe2e5a5__"